<template>
	<v-container id="projects" fluid >
		<v-row
			align="start"
			justify="start"
			class="project-row fill-height"
		>
			<v-col 
				:md=4
				:sm=6
				cols=12
				class="project py-4 py-sm-9 px-sm-6"
				v-for="(project,index) in projects"
				:key="project.id"
			>
	
					<project 
						
						v-bind:project='project'
						:key="project.id"
						:flip="flip[index]"
						@flip="clickToFlip(index)"
					/>
	
	
				
			</v-col>
		</v-row>

	</v-container>
</template>

<script>

import Project from "./Project.vue"
import projects from "../assets/projects.json" 
export default {	
  name: 'ProjectGrid',
  props: {
    msg: String
	},
	components:  {
		Project
	},
	data: function() {
		return {
			projects:projects,
			bingoFlag: false,
			flip:[false,false,false,false,false,false,false,false,false]
		};
	},
	methods: {
		index: function(m,n){
			return ((m-1)+(n-1)*3)
		},
		clickToFlip: function(i){
			this.$set(this.flip, i, !this.flip[i])
			this.checkForBingo(i);
		},
		checkForBingo: function(){
			if(this.bingoFlag) return;
			if(this.$vuetify.breakpoint.smAndDown) return;
			this.flip.forEach((tile,i) => {
				
				if(tile){
					let x = i % 3;
					let y = Math.floor(i/3)
					if(x==0){
						if(this.flip[i+1] && this.flip[i+2]){
							this.$emit("bingo")
							this.bingoFlag = true;
						}
					}
					if(y==0){
						if(this.flip[i+3] && this.flip[i+6]){
							this.$emit("bingo")
							this.bingoFlag = true;
						}
					}
					
					if(this.flip[0] && this.flip[4] && this.flip[8]){
						this.$emit("bingo")
						this.bingoFlag = true;
					}
					
					
					if(this.flip[2] && this.flip[4] && this.flip[6]){
						this.$emit("bingo")
						this.bingoFlag = true;
					}
					

				}
			})
			
		}

	}

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.project-row{
	margin-right: 0; 
	margin-left: 0; 
}
.project{
	/* padding:1.2rem;  */
	height:100%;

}

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>

